import { render } from "./StartChoice.vue?vue&type=template&id=325ee239&scoped=true&ts=true"
import script from "./StartChoice.vue?vue&type=script&lang=ts"
export * from "./StartChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./StartChoice.vue?vue&type=style&index=0&id=325ee239&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-325ee239"]])

export default __exports__